<template>

  <div class="w-full bg-white rounded-[20px] px-[17px] pt-[10px] mt-[15px] pb-[20px] min-h-[200px]">

    <div class="flex justify-between items-center mb-[1.5px]">

      <!-- Offers title -->
      <div class="text-[20px] sm:text-[25px] font-bold text-[#35474B] mb-0 uppercase">
        {{ lang === 'en' ? 'Offers' : 'العروض' }}
      </div>

      <!-- remove -->
      <a href="javascript:void(0)" class="decoration-0 border-0 text-[15px] mb-0 font-normal hover:opacity-50 duration-500" v-if="couponApplied" @click="removeCoupon">
        {{ lang === 'en' ? 'REMOVE' : 'يزيل' }} </a>

    </div>

    <!-- Coupon -->
<!--    we will implement this later-->
<!--    <template v-if="offers.length > 0 && !loading">
      <div class="h-[64px] w-full bg-[#E0E9F0] rounded-[12px] flex justify-between items-center px-[19px] mb-2"
           v-for="(each) in offers" :key="each.id">
        <div>
          <div class="text-[15px] font-normal text-[#3E5463] -mb-[2px]"> {{ lang === 'en' ? 'COUPON' : 'قسيمة' }}</div>
          <div class="text-[18px] font-bold text-[#3E5463]"> {{ each.title }}</div>
        </div>
        <div>
          <div class="flex justify-center items-center w-[39.83px] h-[40.01px] bg-[#C1D5E5] rounded-full" v-if="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="21.467" height="15.69" viewBox="0 0 21.467 15.69">
              <path id="Path_91" data-name="Path 91"
                    d="M40.991,24.818,28.6,37.208a1.635,1.635,0,0,1-2.329,0l-5.782-5.782A1.647,1.647,0,0,1,22.818,29.1l4.618,4.609L38.661,22.488a1.647,1.647,0,1,1,2.329,2.329Z"
                    transform="translate(-20.006 -22.006)" fill="#3e5463"/>
            </svg>
          </div>
          <button class="flex justify-center items-center w-[39.83px] h-[40.01px] bg-[#3e5463] rounded-full" @click="openModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="15.75" height="15.75" viewBox="0 0 15.75 15.75">
              <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                    d="M14.625,8.438H9.563V3.375A1.125,1.125,0,0,0,8.438,2.25H7.313A1.125,1.125,0,0,0,6.188,3.375V8.438H1.125A1.125,1.125,0,0,0,0,9.563v1.125a1.125,1.125,0,0,0,1.125,1.125H6.188v5.063A1.125,1.125,0,0,0,7.313,18H8.438a1.125,1.125,0,0,0,1.125-1.125V11.813h5.063a1.125,1.125,0,0,0,1.125-1.125V9.563A1.125,1.125,0,0,0,14.625,8.438Z"
                    transform="translate(0 -2.25)" fill="#fff"/>
            </svg>
          </button>
        </div>
      </div>
    </template>

    <div class="flex items-center justify-center h-[200px]" v-if="offers.length === 0 && !loading">
      {{ lang == 'en' ? 'No offers found.' : 'لم يتم العثور على أي عروض.' }}
    </div>

    <template v-if="loading">
      <LoaderVue/>
    </template>-->
    <form class="flex gap-2 items-center mt-5" @submit.prevent="applyCoupon" v-if="!couponApplied">
      <input type="text" class="flex-1 h-[50px] border border-gray-200 rounded-[12px] outline-none p-3 text-xl" v-model="code">
      <button type="submit"
              class="w-[100px] rounded-[12px] h-[50px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
              v-if="!couponLoading">
        {{ lang === 'en' ? 'Apply' : 'يتقدم' }}
      </button>
      <button type="button"
              class="w-[100px] rounded-[12px] h-[50px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
              v-if="couponLoading">
              <span
                  class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
      </button>
    </form>

    <div class="h-[64px] w-full bg-[#E0E9F0] rounded-[12px] flex justify-between items-center px-[19px] mb-2 mt-3" v-if="couponApplied">
      <div>
        <div class="text-[15px] font-normal text-[#3E5463] -mb-[2px]"> {{ lang === 'en' ? 'COUPON' : 'قسيمة' }}</div>
        <div class="text-[18px] font-bold text-[#3E5463]">{{coupon?.title}}</div>
      </div>
      <div>
        <div class="flex justify-center items-center w-[39.83px] h-[40.01px] bg-[#C1D5E5] rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" width="21.467" height="15.69" viewBox="0 0 21.467 15.69">
            <path id="Path_91" data-name="Path 91"
                  d="M40.991,24.818,28.6,37.208a1.635,1.635,0,0,1-2.329,0l-5.782-5.782A1.647,1.647,0,0,1,22.818,29.1l4.618,4.609L38.661,22.488a1.647,1.647,0,1,1,2.329,2.329Z"
                  transform="translate(-20.006 -22.006)" fill="#3e5463"/>
          </svg>
        </div>
      </div>
    </div>

    <div v-if="codeError" class="text-red-700 mt-2">{{codeError}}</div>
    <div class="fixed w-full h-full inset-0 !z-50 flex justify-center items-center bg-black/45 duration-500"
         v-if="showModal" :class="{ 'visible' : showModal, 'invisible' : !showModal }">
      <div class="w-full max-w-[575px] duration-500"
           :class="{'opacity-100 scale-100': showModal, 'opacity-0 scale-50' : !showModal}">
        <div class="p-5 lg:p-[33px] bg-[transparent]">
          <div class="bg-white p-6 lg:pt-[37px] lg:pb-[14px] rounded-[20px] w-full relative">
            <div class="absolute top-[-15px] end-[-15px] z-[99999999]">
              <button type="button"
                      class="border border-[#C1D5E5] flex justify-center items-center rounded-full outline-0 bg-white p-0 m-0 w-[44px] h-[44px]"
                      @click="closeModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.273" height="18.272" viewBox="0 0 18.273 18.272">
                  <path id="Path_2192" data-name="Path 2192"
                        d="M10.81,9.272l7.115-7.115A1.184,1.184,0,0,0,16.252.483L9.136,7.6,2.021.483A1.184,1.184,0,0,0,.347,2.157L7.462,9.272.347,16.388a1.184,1.184,0,1,0,1.674,1.674l7.115-7.115,7.115,7.115a1.184,1.184,0,1,0,1.674-1.674Zm0,0"
                        transform="translate(0 -0.136)" fill="#3e5463"/>
                </svg>
              </button>
            </div>
            <div class="p-4">
              <form class="h-[160px] flex items-center justify-center" @submit.prevent="addCoupon">
                <div class="bg-white py-[13px] w-full rounded-[20px] h-[190.4px] mb-[26px]">
                  <div class="text-[22px] sm:text-[25px] font-bold text-[#35474B] uppercase mb-4">
                    {{ lang === 'en' ? 'Add Coupon' : 'أضف قسيمة' }}
                  </div>
                  <div
                      class="h-[59px] px-[15.5px] pt-[6.5px] mb-[40px] w-full rounded-[10px] bg-white shadow-[0_4px_3px_0_#E0E9F0]">
                    <label for="phone" class="text-[16px] font-light text-[#C6A798] block">
                      {{ lang === 'en' ? 'Code' : 'شفرة' }} </label>
                    <input id="phone" type="text" name="phone"
                           class="block outline-0 border-0 bg-transparent text-[#35474B] w-full"
                           autoComplete="off" v-model="code" />
                    <div v-if="orderIdError" class="text-red-700 my-2">{{orderIdError}}</div>
                    <div v-if="codeError" class="text-red-700 my-2">{{codeError}}</div>
                  </div>
                  <div class="absolute bottom-[-20px] w-[90%] left-[5%]">
                    <button type="submit"
                            class="w-full rounded-[12px] h-[64px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
                            v-if="!couponLoading">
                          <span class="inline-block mt-[10px]">
                            {{ lang === 'en' ? 'Save' : 'يحفظ' }}
                          </span>
                    </button>
                    <button type="button" :disabled="true"
                            class="w-full rounded-[12px] h-[64px] bg-[#C6A798] text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
                            v-if="couponLoading">
                    <span
                        class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AuthModal :authModal="authModal" />
  </div>

</template>

<script>

import ApiService from "@/service/apiService";
import getUserInfo from "@/utils/getUserInfo";
import AuthModal from "@/components/AuthModal.vue";

export default {
  components: {AuthModal},
  data() {
    return {
      lang: window?.core?.lang,
      loading: false,
      couponLoading: false,
      offers: [],
      showModal: false,
      code: '',
      userInfo: null,
      authModal: false,
      error: null,
      codeError: null,
      orderIdError: null,
      baskets: [],
      couponApplied: false,
      coupon: null
    }
  },
  mounted() {
    this.getOffers();
    const userInfo = getUserInfo();
    if(userInfo){
      this.userInfo = userInfo;
      this.getBaskets();
    }
  },
  methods: {
    async getOffers() {
      try {
        this.loading = true;
        const url = `/payment/coupon/get`;
        const response = await ApiService.post(url, {});
        this.offers = response.data.data;
        this.offers.forEach((each, index) => {
          if (index === 0) {
            each.active = true;
          } else {
            each.active = false;
          }
          each.imageUrl = `${process.env.VUE_APP_IMAGE_URL}/${each.image}`;
        })
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loading = false;
      }
    },

    async getBaskets() {
        try {
          const url = `/payment/get/basket`;
          const response = await ApiService.post(url, {customer_id: this.userInfo.client.id});
          this.baskets = response.data.data;
        } catch (error) {
          console.error("Error fetching users:", error);
        }
    },

    openModal(){
      if(!this.userInfo){
        this.authModal = true;
        return;
      }
      this.showModal = true;
    },

    closeModal(){
      this.showModal = false;
    },

    async addCoupon(){
      try {
        if(!this.code){
          this.codeError = this.lang == 'en' ? 'Coupon code is required.' : 'رمز القسيمة مطلوب.';
          return;
        }
        this.orderIdError = null;
        this.codeError = null;
        this.couponLoading = true;
        const url = `/payment/coupon/check`;
        if(this.baskets.length == 0){
          this.orderIdError = this.lang == 'en' ? 'Order id is required.' : 'معرف الطلب مطلوب.';
          return;
        }
        const data = {
          customer_id: this.userInfo?.client?.id,
          order_id: this.baskets[0]?.id,
          code: this.code
        }
        const response = await ApiService.post(url, data);
        if(response?.data?.error){
          this.error = response?.data?.error;
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.couponLoading = false;
      }
    },

    async applyCoupon(){
      try {
        if(!this.code){
          this.codeError = this.lang == 'en' ? 'Coupon code is required.' : 'رمز القسيمة مطلوب.';
          return;
        }
        this.codeError = null;
        this.couponLoading = true;
        const url = `payment/coupon/check`;
        if(this.baskets.length == 0){
          this.orderIdError = this.lang == 'en' ? 'Order id is required.' : 'معرف الطلب مطلوب.';
          return;
        }
        const data = {
          customer_id: this.userInfo?.client?.id,
          order_id: this.baskets[0]?.id,
          code: this.code
        }
        const response = await ApiService.post(url, data);
        console.log(response);
        if(response.data.status == 200){
          this.couponApplied = true;
          this.coupon = response.data.data;
          this.$emit('handleDiscount', response?.data?.data);
        }
        if(response?.data?.error){
          this.codeError = response?.data?.error;
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.couponLoading = false;
      }
    },

    async removeCoupon (e){
      e.stopPropagation();
      this.couponApplied = false;
      this.code = null;
    }
  }
}

</script>